import { FC, ReactElement, useEffect, useState } from "react";
import { Box, Tab, TabList, Tabs } from "@chakra-ui/react";
import { BottomNavLayout } from "../components/templates/BottomNavLayout";
import { ResultBody } from "../components/atoms/ResultAnalysis/ResultBody";
import { MonthlyReportBody } from "../components/atoms/ResultAnalysis/MonthlyReportBody";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
dayjs.extend(isSameOrBefore);
import { useAtom } from "jotai";
import { footerIndexAtom } from "../store";
import { useModifiedTranslation } from "../hooks/useModifiedTranslation";
import { BasicPageLayout } from "../components/templates/BasicPageLayout";

/*
 * ログイン後 解析結果グラフ画面
 */
export function AnalysisResult(): ReactElement {
  const t = useModifiedTranslation();

  const [, setFooterIndex] = useAtom(footerIndexAtom);
  // 画面に入るたび推移タブから開始する
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    setFooterIndex(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BottomNavLayout>
      <BasicPageLayout
        title={t("Graph.common.analysisResult")}
        maxW="container.md"
        flex={1}
      >
        <Tabs
          variant="unstyled"
          isFitted
          w="full"
          index={tabIndex}
          onChange={setTabIndex}
          mb={4}
        >
          <TabList bgColor="login.login_button_bg" borderRadius="lg">
            <SelectTab label={t("Graph.tab.trend")} testId="tab-trend" />
            <SelectTab
              label={t("Graph.tab.monthlyReport")}
              testId="tab-monthly-report"
            />
          </TabList>
        </Tabs>

        {/*
         * 推移タブはアンマウントせず display で隠す。
         * アンマウントすると ChartContent の初期化 effect が再走し、
         * ユーザーがOFFにした指標トグルがONに戻ってしまう。
         */}
        <Box
          w="full"
          flex={1}
          display={tabIndex === 0 ? "flex" : "none"}
          flexDirection="column"
        >
          <ResultBody />
        </Box>

        {/* 月次レポートは初回選択時までマウントしない(遅延取得) */}
        {tabIndex === 1 && <MonthlyReportBody />}
      </BasicPageLayout>
    </BottomNavLayout>
  );
}

/*
 * レイアウトパーツ：推移 / 月次レポート の切り替えタブ
 */
const SelectTab: FC<{ label: string; testId: string }> = ({
  label,
  testId,
}) => (
  <Tab
    data-testid={testId}
    fontWeight="bold"
    fontSize={14}
    color="common_text.gray"
    margin={1.5}
    borderRadius="md"
    _active={{ backgroundColor: "white" }}
    sx={{
      "@media (hover: hover)": {
        "&:hover": { backgroundColor: "white" },
      },
    }}
    _selected={{
      color: "common_text.dark",
      bgColor: "white",
      margin: 1.5,
      borderRadius: "md",
    }}
  >
    {label}
  </Tab>
);
